<div class="container content-space-t-1 content-space-t-md-3">
  <div class="w-lg-50 text-center mx-lg-auto mb-7">
    <h3 class="fw-4">Frequently Asked Questions</h3>
  </div>
  <div class="w-md-75 w-lg-65 mx-md-auto">
    <div class="card card-lg">
      <div class="card-body">
        <div id="accordionFAQ" class="accordion accordion-flush">
          <div class="accordion-item">
            <div id="headingOne" class="accordion-header">
              <a
                role="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseOne"
                aria-expanded="false"
                aria-controls="collapseOne"
                class="accordion-button collapsed"
              >
                What methods of payments are supported?
              </a>
            </div>
            <div
              id="collapseOne"
              aria-labelledby="headingOne"
              data-bs-parent="#accordionFAQ"
              class="accordion-collapse collapse"
            >
              <div class="accordion-body">
                You can purchase the themes on Bootstrap Themes via any major
                credit/debit card (via Stripe) or with your Paypal account. We
                don't support cryptocurrencies or invoicing at this time.
              </div>
            </div>
          </div>
          <div class="accordion-item">
            <div id="headingTwo" class="accordion-header">
              <a
                role="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseTwo"
                aria-expanded="true"
                aria-controls="collapseTwo"
                class="accordion-button"
              >
                Can I cancel at anytime?
              </a>
            </div>
            <div
              id="collapseTwo"
              aria-labelledby="headingTwo"
              data-bs-parent="#accordionFAQ"
              class="accordion-collapse collapse show"
            >
              <div class="accordion-body">
                If you'd like a refund please reach out to us at
                <a routerLink="/contact-us">themesgetbootstrap.com</a>. If you
                need technical help with the theme before a refund please reach
                out to the seller first and they can get in touch with us if
                they're unable to resolve the issue.
              </div>
            </div>
          </div>
          <div class="accordion-item">
            <div id="headingThree" class="accordion-header">
              <a
                role="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseThree"
                aria-expanded="false"
                aria-controls="collapseThree"
                class="accordion-button collapsed"
              >
                How do I get a receipt for my purchase?
              </a>
            </div>
            <div
              id="collapseThree"
              aria-labelledby="headingThree"
              data-bs-parent="#accordionFAQ"
              class="accordion-collapse collapse"
            >
              <div class="accordion-body">
                You'll receive an email from Bootstrap themes once your purchase
                is complete.
              </div>
            </div>
          </div>
          <div class="accordion-item">
            <div id="headingFour" class="accordion-header">
              <a
                role="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseFour"
                aria-expanded="false"
                aria-controls="collapseFour"
                class="accordion-button collapsed"
              >
                Which license do I need?
              </a>
            </div>
            <div
              id="collapseFour"
              aria-labelledby="headingFour"
              data-bs-parent="#accordionFAQ"
              class="accordion-collapse collapse"
            >
              <div class="accordion-body">
                There are three license types - <a href="#">Standard</a>,
                <a href="#">Multisite</a>, and <a href="#">Extended</a>. We've
                provided the table below for a quick look at the difference
                between the them, as well as a few examples of ways each license
                could be used. If you'd like more of the nitty-gritty details
                you can find them below and always feel free to reach out with
                any questions you have at
                <a href="#">themesgetbootstrap.com</a>.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer bg-soft-info text-center">
        <p class="mb-0">Still have questions?</p>
        <a routerLink="/contact-us" class="link"
          >Contact our friendly support team
          <i class="bi-chevron-right small ms-1"></i
        ></a>
      </div>
    </div>
  </div>
</div>

<div class="shape-container">
  <div class="shape shape-bottom text-dark">
    <svg
      width="3000"
      height="400"
      viewBox="0 0 3000 400"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 400H3000V0L0 400Z" fill="#fff"></path>
    </svg>
  </div>
</div>
